/**
 * Error handling utilities for API responses
 */

/**
 * Extract a human-readable error message from an API error response
 * Handles various error formats including Pydantic validation errors
 * 
 * @param {Error} error - The error object from axios
 * @param {string} defaultMsg - Default message if no specific message found
 * @returns {string} - Human readable error message
 */
export const getErrorMessage = (error, defaultMsg = 'Error desconocido') => {
  const detail = error.response?.data?.detail;
  
  if (!detail) return defaultMsg;
  
  // String message
  if (typeof detail === 'string') return detail;
  
  // Array of validation errors (Pydantic format)
  if (Array.isArray(detail) && detail.length > 0) {
    return detail.map(err => {
      if (typeof err === 'string') return err;
      return err.msg || err.message || 'Error de validación';
    }).join(', ');
  }
  
  // Single object error
  if (typeof detail === 'object') {
    return detail.msg || detail.message || defaultMsg;
  }
  
  return defaultMsg;
};
